import { FlexRow, FlexRowBetween, PageHeader } from 'components'
import React, { useState, useEffect } from 'react'
import { Form, Checkbox } from 'semantic-ui-react'
import { DotsSixVertical, Plus, Trash } from 'phosphor-react'
import {
    FormColorFormField,
    FormTextFormField,
    SubmitCancelButtons,
} from 'elements'
import { useForm } from 'react-hook-form'
import styled from 'styled-components'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import { AcceptFileType, CommonUtility, InspectionService } from 'utility'
import { FileUploadPicker } from 'components/FileUploadPicker'
import { read, utils } from 'xlsx'
import { TemplateService } from 'utility/services/template'

const ColorBox = styled.div`
    width: 40px;
    height: 40px;
    color: ${({ color }) => color};
    background: ${({ color }) => color};
    border-radius: 50%;
`
const AddResponseButton = styled.div`
    display: flex;
    align-items: center;
    border: solid 2px darkgrey;
    border-style: dashed;
    border-radius: 5px;
    padding: 10px;
    justify-content: center;
`
const BorderResponse = styled.div`
    border: solid 2px darkgrey;
    border-style: dashed;
    border-radius: 5px;
    padding: 10px;
    margin-block: 10px;
    padding: 0.5em;
    margin: 0.5em 0;
    border-radius: 5px;
    background-color: ${({ theme, isDragging }) =>
        isDragging ? theme.colors.hover : theme.colors.white};
    color: ${({ theme, isDragging }) =>
        isDragging ? theme.colors.white : theme.colors.black};
    top: auto !important;
    left: auto !important;
    display: flex;
    justify-content: space-between;
    .w-100 {
        width: 100%;
    }
    .trash {
        svg {
            color: ${({ theme }) => theme.colors.danger};
        }
    }
    .suggestions-container {
        position: relative;
        width: 100%;
    }
    .suggestions-list {
        position: absolute;
        top: 100%;
        left: 0;
        right: 0;
        background: white;
        border: 1px solid #ddd;
        border-radius: 4px;
        max-height: 200px;
        overflow-y: auto;
        z-index: 1000;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }
    .suggestion-item {
        padding: 8px 12px;
        cursor: pointer;
        &:hover {
            background-color: #f5f5f5;
        }
    }
`

const ResponseTypeCheckBoxes = ({ list, onChange, value }) => (
    <>
        {list.map(ele => (
            <FlexRow
                onClick={() => onChange(value === ele.Id ? undefined : ele.Id)}
                className="align-items-center"
                key={ele.Id}
            >
                <Checkbox checked={value === ele.Id} />
                <span className="ms-3">{ele.ControlType}</span>
            </FlexRow>
        ))}
    </>
)

const ResponseItem = ({
    item,
    remove,
    onchange,
    editMode,
    setScoreFromQuestion,
    handleDisplayTextChange,
    suggestions,
    handleSuggestionClick,
    control,
    errors,
    list,
}) => (
    <BorderResponse className="mt-1" isDragging={false}>
        <Form.Group className="w-100">
            <div>
                <DotsSixVertical size={32} />
            </div>
            <Form.Field width={16}>
                <div className="suggestions-container">
                    <FormTextFormField
                        control={control}
                        name={`DisplayText-${item.Id}`}
                        label="DisplayText"
                        value={item.DisplayText}
                        errors={errors?.DisplayText}
                        onChange={value =>
                            handleDisplayTextChange(value, item.Id)
                        }
                    />
                    {suggestions.length > 0 && (
                        <div className="suggestions-list">
                            {suggestions.map((suggestion, i) => (
                                <div
                                    key={i}
                                    className="suggestion-item"
                                    onClick={() =>
                                        handleSuggestionClick(
                                            suggestion,
                                            item.Id,
                                        )
                                    }
                                >
                                    {suggestion}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
                <FlexRow>
                    <FormTextFormField
                        control={control}
                        type="number"
                        name="Score"
                        label="Score"
                        placeholder="0"
                        value={item.Score}
                        errors={errors?.Score}
                        onChange={value => onchange('Score', value, item.Id)}
                    />
                    <FormColorFormField
                        control={control}
                        name="BackColorCode"
                        label="Color"
                        height="38px"
                        value={item.BackColorCode}
                        onChange={value =>
                            onchange('BackColorCode', value, item.Id)
                        }
                    />
                    <div className="flex justify-center items-center w-full">
                        <Checkbox
                            checked={item.IsScoreOnThisResponse}
                            onChange={() => {
                                const isChecked = !item.IsScoreOnThisResponse
                                item.IsScoreOnThisResponse = isChecked
                                if (isChecked) {
                                    setScoreFromQuestion(item.Id, true)
                                } else {
                                    setScoreFromQuestion(item.Id, false)
                                }
                                onchange(
                                    'IsScoreOnThisResponse',
                                    item.IsScoreOnThisResponse,
                                    item.Id,
                                )
                            }}
                        />
                        <span className="ms-3">Take Score from Question</span>
                    </div>
                    {list.length > 1 && !editMode && (
                        <Form.Field
                            className="d-flex align-items-center trash"
                            width={2}
                        >
                            <Trash size={32} onClick={() => remove(item.Id)} />
                        </Form.Field>
                    )}
                </FlexRow>
            </Form.Field>
            <Form.Field width={2} className="mt-4">
                <ColorBox color={item.BackColorCode}>&nbsp;</ColorBox>
            </Form.Field>
        </Form.Group>
    </BorderResponse>
)

const List = ({
    list,
    onDragEnd,
    control,
    errors,
    remove,
    onchange,
    // editMode,
    setScoreFromQuestion,
    handleDisplayTextChange,
    suggestions,
    handleSuggestionClick,
    activeField,
}) => (
    <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="droppable">
            {provided => (
                <div {...provided.droppableProps} ref={provided.innerRef}>
                    {list.map((item, index) => (
                        <Draggable
                            key={item.Id}
                            draggableId={item.Id.toString()}
                            index={index}
                        >
                            {provided => (
                                <div
                                    ref={provided.innerRef}
                                    {...provided.draggableProps}
                                    {...provided.dragHandleProps}
                                >
                                    <ResponseItem
                                        item={item}
                                        remove={remove}
                                        onchange={onchange}
                                        editMode={false}
                                        onDragEnd={onDragEnd}
                                        setScoreFromQuestion={
                                            setScoreFromQuestion
                                        }
                                        handleDisplayTextChange={
                                            handleDisplayTextChange
                                        }
                                        suggestions={
                                            activeField === item.Id
                                                ? suggestions
                                                : []
                                        }
                                        handleSuggestionClick={
                                            handleSuggestionClick
                                        }
                                        control={control}
                                        errors={errors}
                                        list={list}
                                    />
                                </div>
                            )}
                        </Draggable>
                    ))}
                    {provided.placeholder}
                </div>
            )}
        </Droppable>
    </DragDropContext>
)

export const CustomMultipleResponseScreen = () => {
    const {
        control,
        handleSubmit,
        formState: { errors },
    } = useForm({})
    const [responces, setResponces] = useState([])
    const [groupId, setGroupId] = useState(null)
    const [respType, setrespType] = useState(1)
    const [files, setFiles] = useState([])
    const [fileError, setFileError] = useState(false)
    const [loading, setLoading] = useState()
    const [excelData, setExcelData] = useState([])
    const [suggestions, setSuggestions] = useState([])
    const [activeField, setActiveField] = useState(null)

    useEffect(() => {
        setGroupId(Math.random().toString())
        setFiles([])
    }, [])

    const onResponceTypeChnage = id => setrespType(id)

    const setScoreFromQuestion = (responseId, isChecked) => {
        const updatedResponses = responces.map(resp => {
            if (resp.Id === responseId) {
                resp.IsScoreOnThisResponse = isChecked
                if (isChecked) {
                    resp.fetchedScore = 0
                } else {
                    resp.fetchedScore = undefined
                }
            } else if (isChecked) {
                resp.IsScoreOnThisResponse = false
            }
            return resp
        })
        setResponces(updatedResponses)
    }

    const addResposeField = () => {
        setResponces([
            ...responces,
            {
                DisplayText: '',
                BackColorCode: '#808080',
                ForeColorCode: '#FFFFFF',
                Score: '',
                Id: responces.length
                    ? responces[responces.length - 1].Id + 1
                    : 1,
                DisplayOrder: responces.length,
                GroupId: groupId,
                DisplayType: responces.length
                    ? responces[responces.length - 1].Id + 1
                    : 1,
                MultiResponseType: respType,
                tempId: null,
            },
        ])
    }

    const submit = async () => {
        setLoading(true)
        try {
            if (responces.length) {
                responces.forEach((val, index) => {
                    responces[index].DisplayOrder = index
                    responces[index].GroupId = groupId
                    responces[index].MultiResponseType = respType
                    responces[index].Id = val.tempId ? 0 : val.Id
                })
            }
            // Call API to save responses
            await TemplateService.saveTemplateMultiResponse(responces)

            // Optionally, reset or refresh here
        } catch (error) {
            console.error('Submission error:', error)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        setResponces([
            {
                DisplayText: '',
                BackColorCode: '#808080',
                Score: '',
                Id: 0,
            },
        ])
    }, [])

    const onDragEnd = result => {
        if (!result.destination) return
        const items = CommonUtility.reorderList(
            responces,
            result.source.index,
            result.destination.index,
        )
        const orderList = items.map((val, i) => ({
            ...val,
            DisplayOrder: i,
            DisplayType: i,
        }))
        setResponces(orderList)
    }

    const remove = Id => {
        const removed = responces.filter(val => val.Id !== Id)
        setResponces(removed)
    }

    const onchange = (name, data, Id) => {
        const newResponces = [...responces]
        const index = newResponces.findIndex(d => d.Id === Id)
        if (index > -1) {
            newResponces[index][name] = data
        }
        setResponces(newResponces)
    }

    const onFileUpload = async file => {
        setFiles(file)
        try {
            const uploadResponse = await InspectionService.uploadMedia({
                media: file[0].file,
                callfrom: 1,
                type: 'xlsx',
                isExcel: true,
            })
            if (!uploadResponse) {
                const reader = new FileReader()
                reader.onload = async e => {
                    try {
                        const data = new Uint8Array(e.target.result)
                        const workbook = read(data, { type: 'array' })
                        const firstSheet =
                            workbook.Sheets[workbook.SheetNames[0]]
                        const jsonData = utils.sheet_to_json(firstSheet, {
                            header: 1,
                            raw: true,
                        })
                        const columnData = jsonData
                            .slice(1)
                            .map((row, idx) => {
                                const cellRef = `A${idx + 2}`
                                const cell = firstSheet[cellRef]
                                if (cell && cell.w) {
                                    return cell.w
                                }
                                const v = row[0]
                                return v ? v.toString() : ''
                            })
                            .filter(value => value && value.trim() !== '')
                        setExcelData(columnData)
                        if (columnData.length > 0) {
                            const responsesFromExcel = columnData.map(
                                (value, idx) => ({
                                    DisplayText: value,
                                    BackColorCode: '#808080',
                                    ForeColorCode: '#FFFFFF',
                                    Score: '',
                                    Id: idx,
                                    DisplayOrder: idx,
                                    GroupId: groupId,
                                    DisplayType: idx,
                                    MultiResponseType: respType,
                                }),
                            )
                            setResponces(responsesFromExcel)
                        }
                    } catch (error) {
                        setFileError('Error parsing Excel file')
                    }
                }
                reader.onerror = () => setFileError('Error reading file')
                reader.readAsArrayBuffer(file[0].file)
            } else {
                const columnData = uploadResponse
                    .map(item => {
                        if (item && typeof item.Value === 'string') {
                            return item.Value
                        }
                        return null
                    })
                    .filter(Boolean)
                setExcelData(columnData)
                if (columnData.length > 0) {
                    const responsesFromExcel = columnData.map((value, idx) => ({
                        DisplayText: value,
                        BackColorCode: '#808080',
                        ForeColorCode: '#FFFFFF',
                        Score: '',
                        Id: idx,
                        DisplayOrder: idx,
                        GroupId: groupId,
                        DisplayType: idx,
                        MultiResponseType: respType,
                    }))
                    setResponces(responsesFromExcel)
                }
            }
        } catch (error) {
            setFileError('Error processing the file')
        }
    }

    const handleDisplayTextChange = (value, Id) => {
        setActiveField(Id)
        if (value && excelData.length > 0) {
            const searchValue = value.toLowerCase().trim()
            const filtered = excelData.filter(item => {
                const itemLower = item.toString().toLowerCase()
                return itemLower.includes(searchValue)
            })
            setSuggestions(filtered)
        } else {
            setSuggestions([])
        }
        onchange('DisplayText', value, Id)
    }

    const handleSuggestionClick = (suggestion, Id) => {
        onchange('DisplayText', suggestion, Id)
        setActiveField(null)
        setSuggestions([])
    }

    return (
        <div
            className="container mb-5"
            style={{ maxWidth: 900, margin: '40px auto' }}
        >
            <FlexRowBetween>
                <PageHeader header="Custom Multiple Response" hideWeb />
            </FlexRowBetween>
            <Form noValidate>
                <FlexRowBetween className="mt-0 mb-4">
                    <div className="col-4">
                        <ResponseTypeCheckBoxes
                            value={respType}
                            list={[
                                { Id: 1, ControlType: 'Radio Button' },
                                { Id: 2, ControlType: 'List Box' },
                            ]}
                            onChange={onResponceTypeChnage}
                        />
                    </div>
                    <div className="text-align-end">
                        <FileUploadPicker
                            maxFiles={1}
                            maxFileSize={500}
                            accept={AcceptFileType.xlsx}
                            addedNewFiles={onFileUpload}
                            files={files}
                            error={fileError}
                            tagPreview
                            showTakePicture={false}
                            uploadButtonText="Upload File"
                        />
                    </div>
                </FlexRowBetween>
                <List
                    list={responces}
                    remove={remove}
                    control={control}
                    errors={errors}
                    onchange={onchange}
                    editMode={false}
                    onDragEnd={onDragEnd}
                    setScoreFromQuestion={setScoreFromQuestion}
                    handleDisplayTextChange={handleDisplayTextChange}
                    suggestions={suggestions}
                    handleSuggestionClick={handleSuggestionClick}
                    activeField={activeField}
                />
                <AddResponseButton onClick={addResposeField}>
                    <Plus size={24} />
                    <span className="mx-4">Create Response</span>
                </AddResponseButton>
                <SubmitCancelButtons
                    className="mt-4"
                    onSubmit={handleSubmit(submit)}
                    loading={loading}
                    onCancel={() => {}}
                />
            </Form>
        </div>
    )
}
